var map = {
	"./BarChartOutlined.svg": 70045,
	"./BriefCase.svg": 33294,
	"./BusinessCenterOutlined.svg": 56377,
	"./BusinessOutlined.svg": 43750,
	"./CalendarTodayOutlined.svg": 65933,
	"./Folder.svg": 6874,
	"./SettingsOutlined.svg": 85307,
	"./SinoAlerta.svg": 23892,
	"./analytics.svg": 75554,
	"./apps.svg": 4382,
	"./arrow--down.svg": 55391,
	"./arrows--horizontal.svg": 12942,
	"./audio-console.svg": 13524,
	"./bot.svg": 24269,
	"./calculation.svg": 53329,
	"./calculator--check.svg": 87060,
	"./calendar--add.svg": 72247,
	"./calendar--heat-map.svg": 66701,
	"./calendar--settings.svg": 20969,
	"./calendar.svg": 1584,
	"./category--add.svg": 37053,
	"./certificate--check.svg": 56207,
	"./chart--bubble.svg": 27898,
	"./chart--combo.svg": 14226,
	"./chart--custom.svg": 73065,
	"./chart--evaluation.svg": 15054,
	"./chart--line--data.svg": 50304,
	"./chart--line.svg": 53510,
	"./chart--multitype.svg": 80679,
	"./currency--dollar.svg": 52307,
	"./currency.svg": 21471,
	"./dashboard--reference.svg": 8651,
	"./dashboard.svg": 83850,
	"./data--base--alt.svg": 34378,
	"./data--structured.svg": 1085,
	"./data-share.svg": 87196,
	"./database--messaging.svg": 58069,
	"./document--epdf.svg": 61626,
	"./document--export.svg": 19777,
	"./document--import.svg": 54788,
	"./document--multiple-01.svg": 2869,
	"./document--pdf.svg": 5503,
	"./document--requirements.svg": 20907,
	"./document--security.svg": 83561,
	"./document--sketch.svg": 45971,
	"./document.svg": 5585,
	"./edit.svg": 77486,
	"./enterprise.svg": 7087,
	"./error--outline.svg": 44699,
	"./event--schedule.svg": 66383,
	"./event--warning.svg": 50100,
	"./events.svg": 13993,
	"./expand-categories.svg": 31815,
	"./file-storage.svg": 32852,
	"./finance.svg": 3456,
	"./financial-assets.svg": 82383,
	"./group--security.svg": 54823,
	"./home.svg": 79291,
	"./ibm--event-processing.svg": 79962,
	"./ibm-watson--discovery.svg": 54079,
	"./import-export.svg": 83944,
	"./in-progress--warning.svg": 76529,
	"./insert.svg": 89997,
	"./list--checked.svg": 71947,
	"./list.svg": 4822,
	"./money.svg": 32122,
	"./notification.svg": 3391,
	"./notification_alert.svg": 80892,
	"./partnership.svg": 52158,
	"./portfolio.svg": 42906,
	"./receipt.svg": 7458,
	"./repeat.svg": 16184,
	"./report.svg": 76540,
	"./rule--draft.svg": 49919,
	"./search--locate.svg": 36378,
	"./settings--services.svg": 79479,
	"./star--review.svg": 7536,
	"./study--view.svg": 52336,
	"./table--split.svg": 72688,
	"./table-of-contents.svg": 93043,
	"./user--access-locked.svg": 91942,
	"./user--access.svg": 73851,
	"./user--admin.svg": 49654,
	"./user--avatar--filled--alt.svg": 67399,
	"./user--certification.svg": 7261,
	"./user--favorite.svg": 54993,
	"./user--feedback.svg": 72512,
	"./user--follow.svg": 53114,
	"./user--identification.svg": 9863,
	"./user--multiple.svg": 34213,
	"./user--profile.svg": 32980,
	"./user--settings.svg": 48018,
	"./wallet.svg": 5725,
	"./warning--diamond.svg": 18716,
	"./warning.svg": 98046,
	"components/OneShell/Sidebar/icons/BarChartOutlined.svg": 70045,
	"components/OneShell/Sidebar/icons/BriefCase.svg": 33294,
	"components/OneShell/Sidebar/icons/BusinessCenterOutlined.svg": 56377,
	"components/OneShell/Sidebar/icons/BusinessOutlined.svg": 43750,
	"components/OneShell/Sidebar/icons/CalendarTodayOutlined.svg": 65933,
	"components/OneShell/Sidebar/icons/Folder.svg": 6874,
	"components/OneShell/Sidebar/icons/SettingsOutlined.svg": 85307,
	"components/OneShell/Sidebar/icons/SinoAlerta.svg": 23892,
	"components/OneShell/Sidebar/icons/analytics.svg": 75554,
	"components/OneShell/Sidebar/icons/apps.svg": 4382,
	"components/OneShell/Sidebar/icons/arrow--down.svg": 55391,
	"components/OneShell/Sidebar/icons/arrows--horizontal.svg": 12942,
	"components/OneShell/Sidebar/icons/audio-console.svg": 13524,
	"components/OneShell/Sidebar/icons/bot.svg": 24269,
	"components/OneShell/Sidebar/icons/calculation.svg": 53329,
	"components/OneShell/Sidebar/icons/calculator--check.svg": 87060,
	"components/OneShell/Sidebar/icons/calendar--add.svg": 72247,
	"components/OneShell/Sidebar/icons/calendar--heat-map.svg": 66701,
	"components/OneShell/Sidebar/icons/calendar--settings.svg": 20969,
	"components/OneShell/Sidebar/icons/calendar.svg": 1584,
	"components/OneShell/Sidebar/icons/category--add.svg": 37053,
	"components/OneShell/Sidebar/icons/certificate--check.svg": 56207,
	"components/OneShell/Sidebar/icons/chart--bubble.svg": 27898,
	"components/OneShell/Sidebar/icons/chart--combo.svg": 14226,
	"components/OneShell/Sidebar/icons/chart--custom.svg": 73065,
	"components/OneShell/Sidebar/icons/chart--evaluation.svg": 15054,
	"components/OneShell/Sidebar/icons/chart--line--data.svg": 50304,
	"components/OneShell/Sidebar/icons/chart--line.svg": 53510,
	"components/OneShell/Sidebar/icons/chart--multitype.svg": 80679,
	"components/OneShell/Sidebar/icons/currency--dollar.svg": 52307,
	"components/OneShell/Sidebar/icons/currency.svg": 21471,
	"components/OneShell/Sidebar/icons/dashboard--reference.svg": 8651,
	"components/OneShell/Sidebar/icons/dashboard.svg": 83850,
	"components/OneShell/Sidebar/icons/data--base--alt.svg": 34378,
	"components/OneShell/Sidebar/icons/data--structured.svg": 1085,
	"components/OneShell/Sidebar/icons/data-share.svg": 87196,
	"components/OneShell/Sidebar/icons/database--messaging.svg": 58069,
	"components/OneShell/Sidebar/icons/document--epdf.svg": 61626,
	"components/OneShell/Sidebar/icons/document--export.svg": 19777,
	"components/OneShell/Sidebar/icons/document--import.svg": 54788,
	"components/OneShell/Sidebar/icons/document--multiple-01.svg": 2869,
	"components/OneShell/Sidebar/icons/document--pdf.svg": 5503,
	"components/OneShell/Sidebar/icons/document--requirements.svg": 20907,
	"components/OneShell/Sidebar/icons/document--security.svg": 83561,
	"components/OneShell/Sidebar/icons/document--sketch.svg": 45971,
	"components/OneShell/Sidebar/icons/document.svg": 5585,
	"components/OneShell/Sidebar/icons/edit.svg": 77486,
	"components/OneShell/Sidebar/icons/enterprise.svg": 7087,
	"components/OneShell/Sidebar/icons/error--outline.svg": 44699,
	"components/OneShell/Sidebar/icons/event--schedule.svg": 66383,
	"components/OneShell/Sidebar/icons/event--warning.svg": 50100,
	"components/OneShell/Sidebar/icons/events.svg": 13993,
	"components/OneShell/Sidebar/icons/expand-categories.svg": 31815,
	"components/OneShell/Sidebar/icons/file-storage.svg": 32852,
	"components/OneShell/Sidebar/icons/finance.svg": 3456,
	"components/OneShell/Sidebar/icons/financial-assets.svg": 82383,
	"components/OneShell/Sidebar/icons/group--security.svg": 54823,
	"components/OneShell/Sidebar/icons/home.svg": 79291,
	"components/OneShell/Sidebar/icons/ibm--event-processing.svg": 79962,
	"components/OneShell/Sidebar/icons/ibm-watson--discovery.svg": 54079,
	"components/OneShell/Sidebar/icons/import-export.svg": 83944,
	"components/OneShell/Sidebar/icons/in-progress--warning.svg": 76529,
	"components/OneShell/Sidebar/icons/insert.svg": 89997,
	"components/OneShell/Sidebar/icons/list--checked.svg": 71947,
	"components/OneShell/Sidebar/icons/list.svg": 4822,
	"components/OneShell/Sidebar/icons/money.svg": 32122,
	"components/OneShell/Sidebar/icons/notification.svg": 3391,
	"components/OneShell/Sidebar/icons/notification_alert.svg": 80892,
	"components/OneShell/Sidebar/icons/partnership.svg": 52158,
	"components/OneShell/Sidebar/icons/portfolio.svg": 42906,
	"components/OneShell/Sidebar/icons/receipt.svg": 7458,
	"components/OneShell/Sidebar/icons/repeat.svg": 16184,
	"components/OneShell/Sidebar/icons/report.svg": 76540,
	"components/OneShell/Sidebar/icons/rule--draft.svg": 49919,
	"components/OneShell/Sidebar/icons/search--locate.svg": 36378,
	"components/OneShell/Sidebar/icons/settings--services.svg": 79479,
	"components/OneShell/Sidebar/icons/star--review.svg": 7536,
	"components/OneShell/Sidebar/icons/study--view.svg": 52336,
	"components/OneShell/Sidebar/icons/table--split.svg": 72688,
	"components/OneShell/Sidebar/icons/table-of-contents.svg": 93043,
	"components/OneShell/Sidebar/icons/user--access-locked.svg": 91942,
	"components/OneShell/Sidebar/icons/user--access.svg": 73851,
	"components/OneShell/Sidebar/icons/user--admin.svg": 49654,
	"components/OneShell/Sidebar/icons/user--avatar--filled--alt.svg": 67399,
	"components/OneShell/Sidebar/icons/user--certification.svg": 7261,
	"components/OneShell/Sidebar/icons/user--favorite.svg": 54993,
	"components/OneShell/Sidebar/icons/user--feedback.svg": 72512,
	"components/OneShell/Sidebar/icons/user--follow.svg": 53114,
	"components/OneShell/Sidebar/icons/user--identification.svg": 9863,
	"components/OneShell/Sidebar/icons/user--multiple.svg": 34213,
	"components/OneShell/Sidebar/icons/user--profile.svg": 32980,
	"components/OneShell/Sidebar/icons/user--settings.svg": 48018,
	"components/OneShell/Sidebar/icons/wallet.svg": 5725,
	"components/OneShell/Sidebar/icons/warning--diamond.svg": 18716,
	"components/OneShell/Sidebar/icons/warning.svg": 98046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83647;